export default "__VITE_ASSET__BSFF88Qm__"